import { render } from "./edit-company-list-modal.vue?vue&type=template&id=f8115d72"
import script from "./edit-company-list-modal.vue?vue&type=script&lang=js"
export * from "./edit-company-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__